/*! @license Firebase v4.5.0
Build: rev-f49c8b5
Terms: https://firebase.google.com/terms/ */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerFirestore = registerFirestore;

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

require('./firestore/platform_browser/browser_init');

var _config = require('./firestore/platform/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function registerFirestore(instance) {
    (0, _config.configureForFirebase)(instance);
} /**
  * Copyright 2017 Google Inc.
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */

registerFirestore(_app2.default);
//# sourceMappingURL=firestore.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/firestore.js
// module id = 92
// module chunks = 4